import React from 'react';
import PropTypes from 'prop-types';

const ClockExpired = ({ fillColor = '#444444', size = 80 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.75"
      d="M12 7v5l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
);

export default ClockExpired;

ClockExpired.propTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.number
};
